import * as React from "react";

export const CancelFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} fill="none" style={{ cursor: "pointer" }}>
    <path stroke="#8B97A2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 1 1 18M1 1l17 17" />
  </svg>
);

export const DnDIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={28} fill="none">
    <path
      stroke="#21394F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 15.5v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8.5l-5-5-5 5M12 3.5v12"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={41} height={41} fill="none">
    <path
      stroke="#21394F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M23.917 3.416H10.251a3.417 3.417 0 0 0-3.417 3.417v27.333a3.417 3.417 0 0 0 3.417 3.417h20.5a3.417 3.417 0 0 0 3.416-3.417v-20.5l-10.25-10.25ZM27.333 29.041H13.666M27.333 22.209H13.666M17.083 15.375h-3.417"
    />
    <path stroke="#21394F" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M23.916 3.416v10.25h10.25" />
  </svg>
);

export const DocumentPartIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={36} fill="none">
    <g strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}>
      <path
        fill="#D9D9D9"
        stroke="#D9D9D9"
        d="M18.678 1.074H5.138A3.385 3.385 0 0 0 1.751 4.46V31.54a3.385 3.385 0 0 0 3.385 3.386h20.31a3.385 3.385 0 0 0 3.386-3.386V11.23L18.678 1.074Z"
      />
      <path
        stroke="#F6F6F6"
        d="M22.063 26.463H8.523M22.063 19.693H8.523M11.908 12.922H8.522M18.678 1.074V11.23h10.155"
      />
    </g>
  </svg>
);

export const DownloadFileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" style={{ cursor: "pointer" }}>
    <path
      stroke="#8B97A2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.875 15.625v4.167a2.083 2.083 0 0 1-2.083 2.083H5.208a2.083 2.083 0 0 1-2.083-2.083v-4.167M7.291 10.417l5.209 5.208 5.208-5.208M12.5 15.625v-12.5"
    />
  </svg>
);

export const UploadBgImageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke="#23394E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3327 5.33333L7.99935 2L4.66602 5.33333"
      stroke="#23394E"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M8 2V10" stroke="#23394E" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const LinkToImageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99935 4.66602H11.9993C12.4371 4.66602 12.8705 4.75223 13.275 4.91975C13.6794 5.08727 14.0468 5.3328 14.3564 5.64233C14.6659 5.95186 14.9114 6.31932 15.0789 6.72374C15.2465 7.12816 15.3327 7.56161 15.3327 7.99935C15.3327 8.43709 15.2465 8.87054 15.0789 9.27496C14.9114 9.67938 14.6659 10.0468 14.3564 10.3564C14.0468 10.6659 13.6794 10.9114 13.275 11.0789C12.8705 11.2465 12.4371 11.3327 11.9993 11.3327H9.99935M5.99935 11.3327H3.99935C3.56161 11.3327 3.12816 11.2465 2.72374 11.0789C2.31932 10.9114 1.95185 10.6659 1.64233 10.3564C1.01721 9.73125 0.666016 8.8834 0.666016 7.99935C0.666016 7.11529 1.01721 6.26745 1.64233 5.64233C2.26745 5.01721 3.11529 4.66602 3.99935 4.66602H5.99935"
      stroke="#21394F"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M5.33398 8H10.6673" stroke="#21394F" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
